import { render, staticRenderFns } from "./TripDurationForm.vue?vue&type=template&id=5b1dd2ab&"
import script from "./TripDurationForm.vue?vue&type=script&lang=js&"
export * from "./TripDurationForm.vue?vue&type=script&lang=js&"
import style0 from "./TripDurationForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports